import { useMemo } from 'react';
import { getUUID, useUserContext } from '@fff-web/fff-utilities';

/**
 * The user every footer `OptimizelyProvider` passes to the shared client. They must all pass the same
 * shape: each provider re-sets the client's user whenever it differs from its own, and decisions read
 * whichever was set last. Kept in sync with maui so a user lands on the same variation on both:
 * `userId` when logged in, otherwise the anonymous id (`fff_anon_id`, falling back to the GTB UUID).
 */
export const useOptimizelyUser = () => {
  const { userInfo } = useUserContext();
  const isAuthenticated = !!userInfo.loggedIn;
  const userId = userInfo.user.userId;
  const id = isAuthenticated && userId ? String(userId) : getUUID();

  return useMemo(
    () => ({ id, attributes: { is_authenticated: isAuthenticated } }),
    [id, isAuthenticated],
  );
};
